import type { Lucid } from '../../types/types';

const withProduct = (productId: number): Lucid.Site.Product | undefined => {
  switch (productId) {
    case 0:
      return 'chart';

    case 2:
      return 'spark';

    case 3:
      return 'scale';

    default:
      return undefined;
  }
};

export default withProduct;
